<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-6">
                <h5>Colaboradores</h5>
              </div>
              <div class="col-md-6">
                <div style="text-align: right">
                  <router-link
                    :to="{
                      name: 'CadastrarColaborador',
                    }"
                  >
                    <button class="btn_new_user" type="button">
                      Adicionar Colaborador
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr style="background-color: #56008f">
                    <th scope="col">Código</th>
                    <th scope="col">Nome</th>
                    <th scope="col">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="colaborador in state.colaboradores"
                    :key="colaborador.id"
                    :value="colaborador.id"
                  >
                    <td scope="row">{{ colaborador.id }}</td>
                    <td>{{ colaborador.nome }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'AlterarColaborador',
                          params: { id: colaborador.id },
                        }"
                      >
                        <button
                          title="Alterar"
                          type="button"
                          class="btn btn-primary"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </router-link>

                      <button
                        @click="deletar(colaborador.id)"
                        title="Deletar"
                        type="button"
                        class="btn btn-danger"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-trash-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      colaboradores: [],
    });
    onMounted(() => {
      fetchColaborador();
    });
    async function fetchColaborador() {
      try {
        const { data } = await services.colaboradores.getAll({ token });
        state.colaboradores = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletar(id) {
      if (confirm("Deseja deletar está cliente?")) {
        try {
          state.isLoading = true;
          const { data } = await services.colaboradores.delete({
            id: id,
            token,
          });
          if (data.status != 200) {
            alert("Erro ao deletar!.");
          } else {
            fetchColaborador();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletar,
    };
  },
};
</script>
<style scoped>
h5 {
  color: #202020;
}

tr {
  text-align: center;
}

th {
  color: #fff;
  border-bottom: solid 2px #202020 !important;
}

td {
  border-bottom: solid 1px #202020 !important;
  color: #202020;
}

.card {
  border: solid 2px #202020;
  border-radius: 10px;
  background-color: #fff;
}

.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}

.btn_new_user {
  color: #fff;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 5px;
  border: none;
  background-color: #56008f;
  transition: 0.2s;
}

.btn_new_user:hover {
  filter: brightness(1.5);
}

.table-hover > tbody > tr:hover > * {
  color: #202020;
  background-color: rgb(225, 225, 225);
}
</style>
